// extracted by mini-css-extract-plugin
module.exports = {"close":"patient_close__1Djju","open":"patient_open__Je8-w","container":"patient_container__3Kocf"};